import Immutable from 'immutable';
import store from 'store2';
import { push } from 'react-router-redux';

const LOAD = 'question/LOAD';
const LOAD_SUCCESS = 'question/LOAD_SUCCESS';
const LOAD_FAIL = 'question/LOAD_FAIL';
const LOAD_SPLASH_SUCCESS = 'splash/LOAD_SPLASH_SUCCESS';
const LOAD_USER_SUCCESS = 'splash/LOAD_USER_SUCCESS';
const DEL_SUCCESS = 'splash/DEL_SUCCESS';
const DEL_FAIL = 'splash/DEL_FAIL';
const LOAD_UPDATE_FAIL_SIGNATURE_PIC = 'splash/LOAD_UPDATE_FAIL_SIGNATURE_PIC';
const LOAD_UPDATE_SUCCESS_SIGNATURE_PIC = 'splash/LOAD_UPDATE_SUCCESS_SIGNATURE_PIC';

const initialState = Immutable.fromJS({
  Questions: null,
  loading: false,
  errorMessage: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('loading', true)

    case LOAD_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
      return state
        .set('loading', false)
        .set('Questions', action.Questions);
    case LOAD_SPLASH_SUCCESS:
      return state
      .set('loading', false)
      .set('Splash', action.result);
      case LOAD_USER_SUCCESS:
        return state
        .set('loading', false)
        .set('Splash', action.result);
      case DEL_SUCCESS:
        return state
        .set('loading', false);
      case DEL_FAIL:
        return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);
    default:
      return state;
  }
}

export const getCampaignQuestion = (campaignId) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/campaign/question/all/'+campaignId );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, Questions: res });
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const addVideos = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/videos', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, result: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const deleteS3Video = (data) => async (dispatch, getState, api) => {
  try {
    const res = await api.del('/videos/s3/delete', { data });
    if (res.message) {
      dispatch({ type: DEL_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: DEL_SUCCESS });
  } catch (error) {
    dispatch({ type: DEL_FAIL, errorMessage: error });
  }
};

export const addVisiterInfo = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/campaign/splash', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SPLASH_SUCCESS, result: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const updateCampaignCount = (data) => async (dispatch, getState, api) => {
  try {
    const res = await api.put('/campaign/count', { data });
    if (res.message) {
      console.error('unable to increment campaign count', res.message);
      return;
    }
  } catch (error) {
      console.error('unable to increment campaign count. error:', error);
  }
};

export const sendNotifications = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.post('/sendNotifications', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SPLASH_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getUserDetails = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    let res;
    if (id) {
      res = await api.get( '/account/' + id );
      if (res.message) {
        dispatch({ type: LOAD_FAIL, errorMessage: res.message });
        return;
      }
    }
    dispatch({ type: LOAD_USER_SUCCESS});
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const updateSignaturePic = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
   try {
    const res = await api.post('/campaign/s3/signImageBody', { data });
    if (res.message) {
      dispatch({ type: LOAD_UPDATE_FAIL_SIGNATURE_PIC, errorMessage: res.message });
      return;
    }
    return res;
    dispatch({ type: LOAD_UPDATE_SUCCESS_SIGNATURE_PIC });
  } catch (error) {
    dispatch({ type: LOAD_UPDATE_FAIL_SIGNATURE_PIC, errorMessage: error });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/splash.js